import React from 'react';
import { AlertCircleIcon, TrendingUpIcon, TrendingDownIcon, AlertTriangleIcon } from 'lucide-react';
type InsightType = 'positive' | 'negative' | 'warning' | 'info';
interface InsightCardProps {
  type: InsightType;
  message: string;
}
const InsightCard: React.FC<InsightCardProps> = ({
  type,
  message
}) => {
  const getTypeStyles = () => {
    switch (type) {
      case 'positive':
        return {
          bg: 'bg-green-50',
          border: 'border-green-200',
          icon: <TrendingUpIcon size={20} className="text-green-600" data-id="element-51" />,
          title: 'Buena noticia'
        };
      case 'negative':
        return {
          bg: 'bg-red-50',
          border: 'border-red-200',
          icon: <TrendingDownIcon size={20} className="text-red-600" data-id="element-52" />,
          title: 'Atención'
        };
      case 'warning':
        return {
          bg: 'bg-yellow-50',
          border: 'border-yellow-200',
          icon: <AlertTriangleIcon size={20} className="text-yellow-600" data-id="element-53" />,
          title: 'Precaución'
        };
      case 'info':
      default:
        return {
          bg: 'bg-blue-50',
          border: 'border-blue-200',
          icon: <AlertCircleIcon size={20} className="text-blue-600" data-id="element-54" />,
          title: 'Para tu información'
        };
    }
  };
  const {
    bg,
    border,
    icon,
    title
  } = getTypeStyles();
  return <div className={`${bg} ${border} border rounded-lg p-4`} data-id="element-55">
      <div className="flex items-start" data-id="element-56">
        <div className="flex-shrink-0 mt-0.5" data-id="element-57">{icon}</div>
        <div className="ml-3" data-id="element-58">
          <h4 className="text-sm font-medium text-gray-800" data-id="element-59">{title}</h4>
          <p className="mt-1 text-sm text-gray-600" data-id="element-60">{message}</p>
        </div>
      </div>
    </div>;
};
export default InsightCard;